import blue from './blue';
import red from './red';
import yellow from './yellow';
import green from './green';

export default [blue, null, null, null, red, null, null, null, yellow, null, null, null, green, null, null, null];

